import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import './style.scss';
const ConversationGuide = () => {
  const dispatch = useDispatch();
  const closeConversationGuide = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const [displayStatus, setDisplayStatus] = useState({ help_content: true, guide_content: false });

  // // state
  // const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  // const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // // event
  const changeDisplayHelp = () => {
    setDisplayStatus({ help_content: true, guide_content: false });
  };
  const changeDisplayGuide = () => {
    setDisplayStatus({ help_content: false, guide_content: true });
  };

  // const setContentValue = contentStr => {
  //   if (contentStr) {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
  //   } else {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
  //   }
  // };
  return (
    <div className="help_area">
      <div className="help_header">
        <span>대화 가이드</span>
        <i className="ri-close-line" onClick={closeConversationGuide} />
      </div>
      <div className="help_tab_area">
        <div
          className="help_tab"
          onClick={changeDisplayHelp}
          style={{
            borderBottom: displayStatus.help_content ? '2px #0061af solid' : '',
            color: displayStatus.help_content ? '#0061af' : '',
          }}
        >
          챗봇 활용팁
        </div>
        <div
          className="help_tab"
          onClick={changeDisplayGuide}
          style={{
            borderBottom: displayStatus.guide_content ? '2px #0061af solid' : '',
            color: displayStatus.guide_content ? '#0061af' : '',
          }}
        >
          만족도 평가
        </div>
      </div>
      <div className="help_content" style={{ display: displayStatus.help_content ? 'block' : 'none' }}>
        <div className="guide_title">챗봇 활용팁</div>
        <div className="guide_sub">
          챗봇 사용은 처음이신가요?
          <br />
          챗봇과 더 쉽게 대화하는 방법을 알려드릴게요!
        </div>
        <img src="/chat/ibricks/images/guide_01.png" alt="" className="img_help" />
      </div>

      <div className="help_content guide_content" style={{ display: displayStatus.guide_content ? 'block' : 'none' }}>
        <div className="guide_title">만족도 평가</div>
        <div className="guide_sub">
          더욱 똑똑한 &apos;조아용&apos;으로 성장할 수 있도록
          <br />
          많은 관심과 의견 보내주세요!
        </div>

        <img src="/chat/ibricks/images/guide_02.png" alt="" className="img_help" />
      </div>
    </div>
  );
};

export default ConversationGuide;
